import React, { useState } from "react";
import "./LoanForm.css";
import SelfieCapture from "./SelfieCapture";

const LoanForm = ({ onBack, onNext }) => {
  // 🔹 Add required state values
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");

  const [selfie, setSelfie] = useState(null);
  const [showCameraModal, setShowCameraModal] = useState(false);

  // 🔹 Sample dropdown JSON data
  const states = ["Maharashtra", "Delhi", "Karnataka"];

  const cities = {
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Delhi: ["New Delhi", "Dwarka"],
    Karnataka: ["Bengaluru", "Mysuru"],
  };

  const pincodes = {
    Mumbai: ["400001", "400002", "400003"],
    Pune: ["411001", "411002"],
    Nagpur: ["440001"],
    "New Delhi": ["110001"],
    Dwarka: ["110075"],
    Bengaluru: ["560001", "560002"],
    Mysuru: ["570001"],
  };

  // 🔹 function to save selfie
  const handleCapture = (image) => {
    setSelfie(image);
    setShowCameraModal(false);
  };

  return (
    <div className="loanform-wrapper">
      <div className="loan-card">
        <div>
          <h2 className="title">Loan Application</h2>
          <p className="subtitle">Fill your financial & supporting details</p>

          <div className="form-grid">
            <div className="form-item half-width">
              <label>PAN Number</label>
              <input type="text" placeholder="Enter PAN Number" maxLength="10" />
            </div>

            <div className="form-item half-width">
              <label>Monthly Income</label>
              <input type="number" placeholder="Enter Monthly Income" />
            </div>

            <div className="form-item half-width">
              <label>Loan Amount</label>
              <input type="number" placeholder="Enter Loan Amount" />
            </div>

            <div className="form-item half-width">
              <label>Obligation</label>
              <input type="number" placeholder="Existing EMI Obligations" />
            </div>

            {/* 🔹 State Dropdown */}
            <div className="form-item half-width">
              <label>State</label>
              <select
                value={state}
                onChange={(e) => {
                  setState(e.target.value);
                  setCity("");
                  setPincode("");
                }}
              >
                <option value="">Select State</option>
                {states.map((st) => (
                  <option key={st} value={st}>
                    {st}
                  </option>
                ))}
              </select>
            </div>

            {/* 🔹 City Dropdown */}
            <div className="form-item half-width">
              <label>City</label>
              <select
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                  setPincode("");
                }}
                disabled={!state}
              >
                <option value="">Select City</option>
                {state &&
                  cities[state].map((ct) => (
                    <option key={ct} value={ct}>
                      {ct}
                    </option>
                  ))}
              </select>
            </div>

            {/* 🔹 Pincode Dropdown */}
            <div className="form-item half-width">
              <label>Pincode</label>
              <select
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                disabled={!city}
              >
                <option value="">Select Pincode</option>
                {city &&
                  pincodes[city].map((pc) => (
                    <option key={pc} value={pc}>
                      {pc}
                    </option>
                  ))}
              </select>
            </div>

            {/* 🔹 Upload Fields */}
            <div className="form-item half-width upload-box">
              <label>Upload Bank Statement (PDF)</label>
              <input type="file" accept="application/pdf" />
            </div>

            <div className="form-item half-width upload-box">
              <label>Upload Salary Slip</label>
              <input type="file" accept="image/*,application/pdf" />
            </div>

            <div className="form-item half-width upload-box">
              <label>Upload Electricity / Gas Bill</label>
              <input type="file" accept="image/*" capture="user" />
            </div>

            {/* 🔹 Selfie Capture */}
            <div className="form-item full-width upload-box">
              <label>Take a Selfie</label>
              <button
                className="btn-next"
                type="button"
                onClick={() => setShowCameraModal(true)}
              >
                {selfie ? "Retake Selfie" : "Open Camera"}
              </button>

              {selfie && <img src={selfie} alt="Selfie Preview" />}
            </div>
          </div>
        </div>

        {/* 🔹 Buttons */}
        <div className="btn-row">
          <button className="btn-back" onClick={onBack}>
            Back
          </button>
          <button className="btn-next" onClick={onNext}>
            Submit
          </button>
        </div>

        {/* 🔹 Selfie Popup */}
        <SelfieCapture
          show={showCameraModal}
          handleClose={() => setShowCameraModal(false)}
          onCapture={handleCapture}
        />
      </div>
    </div>
  );
};

export default LoanForm;
